<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4>Inbound Delivery</h4>
                </div>
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
                    <vs-button :to="{ name: 'inbound-delivery-create' }" class="btn mb-4 md:mb-0 mr-1" icon="add">Add
                    </vs-button>
                    <vs-button :to="{ name: 'inbound-delivery-view', params: { id: selectedId } }" class="mb-4 md:mb-0 mr-1" icon="remove_red_eye" :disabled="selectedId == ''">View
                    </vs-button>
                    <vs-button class="mb-4 md:mb-0 mr-1" @click="removeItem" icon="delete" :disabled="selectedId == ''" v-bind:class="{ hidden: !this.hasAccess('delete') }">
                        Delete</vs-button>
                    <vs-button class="mb-4 md:mb-0 mr-1" @click="filterInit" icon="filter_list">Filter
                    </vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="getTemplate({endpoint: 'inbound/inbounddelivery', name: 'inbound_delivery'})">Template</vs-dropdown-item>
                            <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                            <vs-dropdown-item @click="exportExel">Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <!-- </div> -->
                </div>
            </div>
            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="contacts" colResizeDefault="shift"
                :animateRows="false" :pagination="false" rowSelection="single" @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"></ag-grid-vue>
                <p class="text-right"><b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }}  total entries</b></p>
                <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
        </vx-card>

        <vs-prompt @accept="fetchData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <vs-input v-model="filter.inbound_reference" class="mb-2 w-full" label="Reference" />
                <label class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
                <label class="vs-input--label">Supplier</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.supplier_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, customer)"
                >
                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
                <label class="vs-input--label">Req. Del. Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.req_arrival_date_start" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">To</vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.req_arrival_date_end" />
                    </vs-col>
                </vs-row>
                <label class="vs-input--label">Status</label>
                <vs-select
                    class="selectExample"
                    v-model="filter.status_id"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item v-for="(item, index) in status" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
            </div>
        </vs-prompt>

        <input type="file" ref="file" style="display: none" v-on:change="uploadInboundFile" />
    </div>
</template>

<script>
    import {
        AgGridVue
    } from "ag-grid-vue";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
    import {
        saveAs
    } from "file-saver";
    import vSelect from "vue-select";

    export default {
        components: {
            AgGridVue,
            vSelect,
            flatPickr
        },
        data() {
            return {
                fileInboundUpload: null,
                isLoading: false,
                popupUpload: false,
                searchQuery: "",
                gridOptions: {},
                maxPageNumbers: 7,
                gridApi: null,
                contacts: null,
                columnDefs: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                selectedId: "",
                status: [],
                showFilter: false,
                filter: {
                    fetchCount: 0,
                    inbound_reference: "",
                    client_id: null,
                    req_arrival_date_start: null,
                    req_arrival_date_end: null,
                    supplier_id: null,
                    status_id: 1
                },
                client: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients',
                    objectKey: 'client_code'
                },
                customer: {
                    data: [],
                    loading: false,
                    endpoint: 'master/customers',
                    objectKey: 'name'
                },
                totalPage: 0,
                currentPage: 1,
                dataFrom: 0,
                dataTo: 0,
                dataTotal: 0,
            };
        },
        watch: {
            "$store.state.windowWidth"(val) {
                if (val <= 576) {
                    this.maxPageNumbers = 4;
                    this.gridOptions.columnApi.setColumnPinned("email", null);
                } else this.gridOptions.columnApi.setColumnPinned("email", "left");
            },
            isLoading: function () {
                if (this.isLoading) {
                    this.$vs.loading();
                } else {
                    this.$vs.loading.close();
                }
            },
            currentPage: function() {
                this.fetchData();
            }
        },
        methods: {
            uploadInboundFile(event) {
                this.fileInboundUpload = event.target.files[0];
                let formData = new FormData();
                formData.append("file", this.fileInboundUpload);
                this.isLoading = true;
                this.$http
                    .post(
                        "/inbound/inbounddelivery/report/import_excel",
                        formData, {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        }
                    )
                    .then(resp => {
                        this.isLoading = false;
                        const message = resp.data.message || 'Upload Data Inbound Successfully'
                        this.fetchData();
                        this.$vs.notify({
                            color: "success",
                            title: "Upload Success",
                            text: message
                        });
                    })
                    .catch(error => {
                        this.isLoading = false;
                        const message = error.response.data.message ?
                            error.response.data.message :
                            "Something went wrong";
                        this.$vs.notify({
                            color: "danger",
                            title: "Upload Failed",
                            text: message
                        });
                    });
                this.$refs.file.value = null;
            },
            exportExel() {
                this.isLoading = true;
                this.$http
                    .post("inbound/inbounddelivery/report/download_excel", this.filter, {
                        responseType: "blob"
                    })
                    .then(response => {
                        var blob = new Blob([response.data], {
                            type: "application/pdf"
                        });
                        this.isLoading = false;
                        saveAs(blob, "Inbound-list-export.xlsx");
                    });
            },
            filterData() {
                this.isLoading = true;
                this.$http
                    .post("master/clients/filter/search", this.filter)
                    .then(resp => {
                        this.clients = resp.data;
                        this.isLoading = false;
                    });
            },
            searchArea(search, loading) {
                if (search.length > 2) {
                    loading(true);
                    const data = {
                        name: search
                    };
                    this.$http
                        .post("master/areas/filter/search", data)
                        .then(res => {
                            this.areaOptions = res.data;
                            loading(false);
                        })
                        .catch(() => {
                            this.searchArea(search, loading);
                        });
                }
            },
            fetchData() {
                this.isLoading = true;
                this.setFilter(this.filter);
                this.$http
                    .post("inbound/inbounddelivery?page="+this.currentPage, this.filter)
                    .then(resp => {
                        this.contacts = resp.data.data;
                        this.isLoading = false;
                        this.totalPage = resp.data.last_page;
                        this.dataTotal = resp.data.total;
                        this.dataFrom = resp.data.from;
                        this.dataTo = resp.data.to;
                    })
                    .catch(resp => {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.fetchData();
                            },
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                    });
            },
            refreshData() {
                this.fetchData();
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val);
            },
            onSelectionChanged() {
                var selectedRows = this.gridApi.getSelectedRows();
                var selectedRowsString = "";
                selectedRows.forEach(function (selectedRow, index) {
                    if (index !== 0) {
                        selectedRowsString += ", ";
                    }
                    selectedRowsString += selectedRow.id;
                });
                this.selectedId = selectedRowsString;
            },
            onRemoveSelected() {
                var selectedData = this.gridApi.getSelectedRows();
                var res = this.gridApi.updateRowData({
                    remove: selectedData
                });
            },
            viewData() {
                this.$router.push({
                    name: "inbound-delivery-view",
                    params: {
                        id: this.selectedId
                    }
                });
            },
            removeItem() {
                this.$vs.dialog({
                    type: "confirm",
                    color: "danger",
                    title: `Confirm`,
                    text: "Are you sure want to Delete this Inbound ?",
                    accept: this.acceptAlert
                });
            },
            acceptAlert() {
                this.isLoading = true;
                this.$http
                    .delete(
                        "inbound/inbounddelivery/" + this.selectedId + "/destroy"
                    )
                    .then(res => {
                        this.isLoading = false;
                        this.onRemoveSelected();
                        this.$vs.notify({
                            color: "success",
                            title: "Inbound Delivery deleted",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: "The selected Inbound Delivery was successfully deleted"
                        });
                    })
                    .catch(error => this.handleError(error))
            },
            filterInit() {
                if(this.filter.fetchCount < 1) {
                    this.isLoading = true
                    this.fetchDropdowns()
                    .then(() => {
                        this.isLoading = false
                        this.showFilter = true
                        this.filter.fetchCount++
                    })
                    .catch(() => {
                        this.isLoading = false
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.filterInit();
                            },
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                    })
                }
                else {
                    this.showFilter = true
                }
            },
            fetchDropdowns() {
                return Promise.all([
                    this.$http.post("/master/clients"),
                    this.$http.post("/master/customers"),
                    this.$http.get("/inbound/inboundstatus"),
                ]).then(
                    this.$http.spread((clients, suppliers, status) => {
                        this.client.data = clients.data.data;
                        this.customer.data = suppliers.data.data;
                        this.status = status.data
                        this.status.unshift({
                            id: null,
                            name: 'Any'
                        })

                        this.customer.data.unshift({
                            id: null,
                            name: 'Any'
                        })

                        this.client.data.unshift({
                            id: null,
                            client_code: 'Any'
                        })
                    })
                );
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.$http.post("unlock_all");
            this.fetchData()
        },
        beforeMount() {
            const filter = this.getFilter();

            if(filter) {
                this.filter = filter
                this.filter.fetchCount = 0;
            }
            
            if (this.isLoading) {
                this.$vs.loading();
            }
            this.columnDefs = [{
                    headerName: "Inbound ID",
                    field: "id",
                    width: 120,
                    filter: true
                },
                {
                    headerName: "Client ID",
                    field: "client_code",
                    filter: true,
                    width: 120
                },
                {
                    headerName: "Reference",
                    field: "reference",
                    filter: true,
                    width: 120
                },
                {
                    headerName: "Req. Del. Date",
                    field: "req_del_date",
                    filter: true,
                    width: 120
                },
                {
                    headerName: "Supplier Name",
                    field: "supplier_name",
                    filter: true,
                    width: 120
                },
                {
                    headerName: "Inbound Status",
                    field: "status_name",
                    filter: true,
                    width: 120
                },
                {
                    headerName: "Upload/Input Date",
                    field: "created_at",
                    filter: true,
                    width: 120
                },
            ];

            this.gridOptions.getRowHeight = function(params) {
                return 35;
            }
        }
    };

</script>
